import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMaterialSymbolsSortFilter = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 21,
	height: 21,
	viewBox: "0 0 448 448",
	xmlSpace: "preserve",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "currentColor",
		children: [
			/* @__PURE__ */ _jsx("path", { d: "M310 347c-4.33 0-7.96-1.47-10.9-4.42-2.93-2.94-4.39-6.58-4.4-10.9v-92l-88.7-113c-3.82-5.11-4.39-10.5-1.71-16.1s7.33-8.43 13.9-8.43h214c6.63 0 11.3 2.81 14 8.43s2.11 11-1.73 16.1l-88.7 113v92c0 4.34-1.47 7.99-4.4 10.9-2.94 2.94-6.57 4.41-10.9 4.4z" }),
			/* @__PURE__ */ _jsx("path", { d: "M0 192 72.5 0h41.6l72.5 192h-39.7l-16.4-46.1H56L40.5 192zm67.7-78.7H118l-23.2-72h-2.9z" }),
			/* @__PURE__ */ _jsx("path", { d: "M24 448v-36.5l95.9-121H27.8v-34.6h134v36.5l-95 121h95.9V448z" })
		]
	})
});
export default SvgMaterialSymbolsSortFilter;
